export const FAMILY_STATUSES = ["single", "married", "divorced", "widowed"] as const;
export type FamilyStatus = (typeof FAMILY_STATUSES)[number];

export function getFamilyStatusLabel(
  status: string | null | undefined,
  gender: string | null | undefined,
  t: (key: string) => string,
): string {
  if (!status) return "";
  if (!FAMILY_STATUSES.includes(status as FamilyStatus)) return String(status);
  const suffix = gender === "male" || gender === "female" ? `_${gender}` : "";
  return t(`familyStatus.${status}${suffix}`);
}

export function getFamilyStatusOptions(
  gender: string | null | undefined,
  t: (key: string) => string,
): { value: FamilyStatus; label: string }[] {
  return FAMILY_STATUSES.map(function buildOption(status) {
    return { value: status, label: getFamilyStatusLabel(status, gender, t) };
  });
}
